import React from 'react';
import b_ from 'b_';

import genSrcSet from 'client/common/utils/srcset';

import VideoImage from './images/video.png';
import VideoImage2x from './images/video@2x.png';
import ExampleImage from './images/example.png';
import ExampleImage2x from './images/example@2x.png';

import './side-block.css';

const b = b_.with('side-block');

const sets = {
    video: genSrcSet([VideoImage, VideoImage2x]),
    example: genSrcSet([ExampleImage, ExampleImage2x])
};

interface SideBlockProps {
    imageSet: keyof typeof sets;
    text: string;
    link: string;
    className?: string;
}

export default function SideBlock({imageSet, text, link, className = ''}: SideBlockProps) {
    return (
        <a href={link} target='_blank' rel='noopener noreferrer' className={`${b()} ${className}`}>
            <img srcSet={sets[imageSet]} className={b('image')} />
            <p className={b('text')}>{text}</p>
        </a>
    );
}
